import clsx from 'clsx'
import { SparklesIcon, XIcon } from 'lucide-react'
import { PropsWithChildren } from 'react'
import { colors } from '@/styles/colors'

interface ChatHeaderProps extends PropsWithChildren {
  onClose?: () => void | null
  title: string
  agentColor?: string
}

const ChatHeader = ({ onClose, children, title, agentColor = colors.orange[500] }: ChatHeaderProps) => (
  <header className="flex justify-between border-b border-1 p-4 bg-white dark:bg-dark-card min-w-0 border-gray-300 dark:border-gray-600">
    <div className="flex gap-2 items-center min-w-0 flex-shrink">
      <SparklesIcon className="w-10 h-10 flex-shrink-0" style={{ color: agentColor }} />
      <h4 className="font-semibold truncate">{title}</h4>
    </div>
    <div className="flex items-center gap-4 flex-shrink-0">
      <div
        className={clsx(
          'flex gap-2 pr-2 items-center',
          onClose && 'border-r border-gray-300 dark:border-gray-600'
        )}
      >
        {children}
      </div>
      {onClose && (
        <XIcon
          className="w-10 cursor-pointer flex-shrink-0 text-gray-400 dark:text-gray-500 hover:text-gray-600 dark:hover:text-gray-300 transition-colors"
          onClick={onClose}
        />
      )}
    </div>
  </header>
)

export default ChatHeader
